import * as React from "react";
import { Button } from "../ui/button";
import { BiPlus } from "react-icons/bi";
import { FaEdit } from "react-icons/fa";
import { toaster } from "../ui/toaster";
import { useEffect, useState } from "react";
import { useWebHelper } from "@viabl/echo-web-client-core";
import { FloatingLabelInput } from "../ui/floating-input-label";
import { DialogBody, DialogContent, DialogFooter, DialogRoot, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Dialog, Field, Fieldset, Separator, Text, useDisclosure, Portal, Select, createListCollection, ListCollection } from '@chakra-ui/react';
import { IRole } from "../../pages/echoRoles"

interface IProps {
    cb: Function,
    existingRole: IRole | null,
    intent: "edit" | "create", //lets us use this component for both editing and creating announcements, just need to change some of the text and the api call
}

export default function RolesEditor(props: IProps) {
    const { onOpen, onClose } = useDisclosure();

    const [id, setId] = useState<string>("")
    const [role, setRole] = useState<string>("")

    const [open, setOpen] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const webHelpers = useWebHelper();

    const validateForm = (): boolean => {
        const newErrors: { [key: string]: string } = {}

        // if (!id.trim()) {
        //     newErrors.id = "ID is required"
        // }
        if (!role || !role.trim()) {
            newErrors.name = "Name is required"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleClickOpen = () => {

        onOpen();
        setOpen(true);
        setErrors({})

        if (props.intent === "edit" && props.existingRole != null) {
            setId(props.existingRole.id)
            setRole(props.existingRole.role)
        }
        else {
            setRole("")
        }
    }

    const handleCreate = () => {
        if (!validateForm()) {
            toaster.create({
                title: "Validation Error",
                description: "Please fill in all required fields",
                type: "error",
            })
            return
        }

        let newRole = {
            role: role,
        }

        webHelpers.PutAsync("/api/role", "auth", newRole).then((data: any) => {
            handleClose()
            props.cb()

            toaster.create({
                title: `Created Role`,
                type: "success",
            })
        })
    }

    const handleEdit = () => {
        if (!validateForm()) {
            toaster.create({
                title: "Validation Error",
                description: "Please fill in all required fields",
                type: "error",
            })
            return
        }

        let newRole = {
            role: role,
        }

        webHelpers.PostAsync("/api/role/" + id, "auth", newRole).then((data: any) => {
            handleClose()
            props.cb()

            toaster.create({
                title: `Updated Category`,
                type: "success",
            })
        })
    }

    const handleSubmit = () => {
        if (props.intent === "edit") {
            handleEdit()
        }
        else {
            handleCreate()
        }
    }

    const handleNameKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleSubmit()
        }
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    const handleNameChange = (e: React.FormEvent<HTMLInputElement>) => {
        setRole(e.currentTarget.value);
    }

    return (
        <>
            <DialogRoot
                open={open}
                aria-describedby="alert-dialog-slide-description"
                size={{ base: "md", "2xl": "sm" }}
            >
                <Dialog.Backdrop />
                <DialogTrigger>
                    <Button bg={"AbleBlue"} color={"white"} size={"sm"}
                        _hover={{ bg: "AbleYellow", color: "white" }}
                        _active={{ bg: "#ECB500" }}
                        onClick={handleClickOpen}>
                        {props.intent === "create" ? <BiPlus /> : <FaEdit />}
                        {props.intent === "create" ? "Add Role" : "Edit"}
                    </Button>
                </DialogTrigger>
                <DialogContent marginTop={"0px"} marginBottom={"0px"}>
                    <DialogTitle>{props.intent === "create" ? "Add Role" : "Edit Role"}</DialogTitle>
                    <DialogBody padding={"10px"}>
                        <Fieldset.Root>
                            <Field.Root marginTop={"3px"}>
                                <Separator marginY={"10px"} />
                                <FloatingLabelInput label="Role" value={role} onChange={handleNameChange} onKeyDown={handleNameKeyDown} />
                                {errors.categoryName && (
                                    <Text color="red.500" fontSize="sm" marginTop="4px">
                                        {errors.categoryName}
                                    </Text>
                                )}
                            </Field.Root>
                            <Separator marginY={"10px"} />
                        </Fieldset.Root>
                    </DialogBody>
                    <DialogFooter>
                        <Button onClick={handleSubmit}
                            disabled={false}
                            bg={"AbleBlue"}
                            color={"white"}
                            _hover={{ color: "AbleYellow" }}>{props.intent === "edit" ? "Edit " : "Create Role"}</Button>
                        <DialogTrigger>
                            <Button onClick={handleClose} colorScheme="red" marginLeft={"10px"}>Cancel</Button>
                        </DialogTrigger>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </>
    );
}